import React from "react"
import { useDispatch } from "react-redux"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import { ITEM, MAKE_WISH_TRUE } from "constants/index"
import { updateShowSelectGeniesBottomSheet } from "appRedux/slices/wishListSlice"
import TickIcon from "components/atoms/_icons/TickIcon"
import withRoleBasedPermission from "components/HOCs/withRoleBasedPermission"

export default function MakeWishTrueButton() {
  const dispatch = useDispatch()

  function handleMakeWishTrue() {
    dispatch(updateShowSelectGeniesBottomSheet(true))
  }

  return (
    <>
      <MakeTrueButtonWithRoleBasedPermission
        resource={ITEM}
        action={MAKE_WISH_TRUE}
      >
        <MakeTrueButtonWrapper onClick={handleMakeWishTrue}>
          <Button>
            <TickIcon/>
          </Button>
        </MakeTrueButtonWrapper>
      </MakeTrueButtonWithRoleBasedPermission>
    </>
  )
}

const Container = styled(Stack)(({ theme }) => ({
  width: "100%",
  height: "40px",
  justifyContent: "center",
  alignItems: "center"
}))

const MakeTrueButtonWrapper = styled("div")(({ theme }) => ({
  width: "128px",
  height: "100%",
  borderRadius: "64px",
  padding: "2px",
  border: `1px solid ${theme.palette.gray["13"]}`,
  background: `linear-gradient(to right, ${theme.palette.gray["14"]}, ${theme.palette.gray["15"]})`,
  boxShadow: `0 0 1px 0 ${theme.palette.gray["11"]}, 0 6px 10px -6px ${theme.palette.gray["14"]}`
}))

const Button = styled("button")(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "64px",
  outline: "none",
  border: "none",
  background: `linear-gradient(to right, ${theme.palette.primary["6"]}, ${theme.palette.primary["5"]})`,

  "& path": {
    fill: "#FFFFFF"
  }
}))

const MakeTrueButtonWithRoleBasedPermission = withRoleBasedPermission(Container)
